/**
 * EAkte Plus API
 * API eakteplus document metadata api
 *
 * OpenAPI spec version: 1.0.0
 * Contact: ehgidencores@eulerhermes.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * filter operation for text document metadata
 */
export type FilterDocumentMetadataTextOperationEnum = 'EQUAL' | 'NOT_EQUAL' | 'IN' | 'NOT_IN' | 'LIKE' | 'NOT_LIKE';

export const FilterDocumentMetadataTextOperationEnum = {
	EQUAL: '=' as FilterDocumentMetadataTextOperationEnum,
	NOT_EQUAL: '!=' as FilterDocumentMetadataTextOperationEnum,
	LIKE: 'ENTHÄLT' as FilterDocumentMetadataTextOperationEnum,
	NOT_LIKE: 'NICHT ENTHÄLT' as FilterDocumentMetadataTextOperationEnum,
};
